/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNameWiseUsage {
    getFixupPrototypeFunction() { return ServiceNameWiseUsage.fixupPrototype; }

    static newInstance(model: Partial<ServiceNameWiseUsage>): ServiceNameWiseUsage {
        let obj = Object.assign(new ServiceNameWiseUsage(), model);
        ServiceNameWiseUsage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNameWiseUsage>): ServiceNameWiseUsage {
        if (!model) return null;
        return ServiceNameWiseUsage.newInstance(<ServiceNameWiseUsage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNameWiseUsage) {
        if (!obj) return;

        models.ServiceNameWiseUsage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNameWiseUsage): boolean {
        Object.setPrototypeOf(obj, ServiceNameWiseUsage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.service_accounts) {
            for (let val of this.service_accounts) {
                models.CloudAccountWiseUsage.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the service
     */
    service_name: string;

    /**
     * Group by field for the service usage
     */
    group_by: string;

    /**
     * Day of the usage data
     */
    day: string;

    /**
     * List of cloud account-wise usage data
     */
    service_accounts: Array<models.CloudAccountWiseUsage>;

}
